import React, { useState, useEffect } from 'react';
import { X, Menu, Cookie } from 'lucide-react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import AboutPage from './AboutPage';

// Updated paintings data with numbered names
const paintings = [
  {
    id: 1,
    title: "Come To The Mountain",
    artist: "Malinda du Preez",
    description: "A detailed watercolor painting showcasing intricate details, of a snow covered mountain in the Souther Freestate of South Africa.                         PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 12.00,
    versions: [
      "./image/paintings/wc1-full.jpg",
      "./image/paintings/wc1-variant1.jpg",
      "./image/paintings/wc1-variant2.jpg"
    ]
  },
  {
    id: 2,
    title: "Golden Highway",
    artist: "Malinda du Preez",
    description: "A vibrant watercolor landscape with rich, flowing colors and ink additions.    PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 12.00,
    versions: [
      "./image/paintings/wc2-full.jpg",
      "./image/paintings/wc2-variant1.jpg",
      "./image/paintings/wc2-variant2.jpg"
    ]
  },
  {
    id: 3,
    title: "Icy Sunset",
    artist: "Malinda du Preez",
    description: "Experience the glow of nature on ice in this serene depiction of an icy sunset over a frozen lake.     PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 12.00,
    versions: [
      "/image/paintings/wc3-full.jpg",
      "/image/paintings/wc3-variant1.jpg",
      "/image/paintings/wc3-variant2.jpg"
    ]
  },
  {
    id: 4,
    title: "The Pond",
    artist: "Malinda du Preez",
    description: "A beautiful pond in a rolling field. Water colour",
    price: 12.00,
    versions: [
      "/image/paintings/wc4-full.jpg",
      "/image/paintings/wc4-variant1.jpg",
      "/image/paintings/wc4-variant2.jpg"
    ]
  },
  {
    id: 5,
    title: "Islands",
    artist: "Malinda du Preez",
    description: "A bold and expressive watercolor composition of a magnificent sunset over a tree island.   PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 12.00,
    versions: [
      "/image/paintings/wc5-full.jpg",
      "/image/paintings/wc5-variant1.jpg",
      "/image/paintings/wc5-variant2.jpg"
    ]
  },
  {
    id: 6,
    title: "Spring Showers",
    artist: "Malinda du Preez",
    description: "A delicate watercolor exploring the capturing of water reflections in a city scape.   PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 12.00,
    versions: [
      "/image/paintings/wc6-full.jpg",
      "/image/paintings/wc6-variant1.jpg",
      "/image/paintings/wc6-variant2.jpg"
    ]
  },
  {
    id: 7,
    title: "Revelation Nights",
    artist: "Malinda du Preez",
    description: "A dynamic watercolor that captures the essence of a starry sky on a dark winter night.   PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 20.00,
    versions: [
      "/image/paintings/wc7-full.jpg",
      "/image/paintings/wc7-variant1.jpg",
      "/image/paintings/wc7-variant2.jpg"
    ]
  },
  {
    id: 8,
    title: "The Dock",
    artist: "Malinda du Preez",
    description: "An abstract watercolor scene showing boats at a dockside.   PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 12.00,
    versions: [
      "/image/paintings/wc8-full.jpg",
      "/image/paintings/wc8-variant1.jpg",
      "/image/paintings/wc8-variant2.jpg"
    ]
  },
  {
    id: 9,
    title: "The Fathers Wish",
    artist: "Malinda du Preez",
    description: "Inspired by the bounty of the earth, this depicts a successful harvest at the end of summer.   PLEASE email info at starklingsolutions dot co dot za with your request. Also complete your payment by clicking on the purchase button on this page. To purchase your digital copy (NO frame. Only a digital copy of this painting)",
    price: 12.00,
    versions: [
      "/image/paintings/wc9-full.jpg",
      "/image/paintings/wc9-variant1.jpg",
      "/image/paintings/wc9-variant2.jpg"
    ]
  },
 // {
   // id: 10,
    //title: "WC 10",
    //artist: "Artist 10",
    //description: "A harmonious watercolor blending natural elements.",
    //price: 389.99,
    //versions: [
     // "/images/paintings/wc10-full.jpg",
     // "/images/paintings/wc10-variant1.jpg",
     // "/images/paintings/wc10-variant2.jpg"
   // ]
 // }
];

const CookieConsent = ({ onAccept }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 flex items-center justify-between z-50">
      <div className="flex items-center">
        <Cookie className="mr-4" />
        <p>This website uses cookies to enhance your browsing experience.</p>
      </div>
      <div>
        <button 
          onClick={onAccept} 
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded ml-4"
        >
          Accept Cookies
        </button>
      </div>
    </div>
  );
};

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-gray-900 text-white">
      <div className="container mx-auto flex justify-between items-center p-4">
        <div className="text-2xl font-bold">Starkling Art Watercolour Gallery</div>
        
        <div className="md:hidden">
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="focus:outline-none"
          >
            <Menu size={24} />
          </button>
        </div>

        <div className="hidden md:flex space-x-6">
          <a href="/" className="hover:text-blue-300">Home</a>
                   <a href="./about" className="hover:text-blue-300">About</a>
             <a href="./contact" className="hover:text-blue-300">Contact</a>
        </div>

        {isMenuOpen && (
          <div className="absolute top-16 left-0 right-0 bg-gray-900 md:hidden">
            <div className="flex flex-col items-center space-y-4 p-4">
              <a href="/" className="hover:text-blue-300">Home</a>
             
              <a href="./about" className="hover:text-blue-300">About</a>
              <a href="./contact" className="hover:text-blue-300">Contact</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white text-center py-4">
      <p className="mb-2">&copy; 2024 Starkling Solutions. All rights reserved.</p>
      <div className="flex justify-center space-x-6">
        <a href="#" className="hover:text-blue-300">
          Terms & Conditions
        </a>
        <a href="#" className="hover:text-blue-300">
          Privacy Policy
        </a>
      </div>
    </footer>
  );
};


const ArtGallery2 = () => {
  const [selectedPainting, setSelectedPainting] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(0);
  const [showCookieConsent, setShowCookieConsent] = useState(true);

  // Add the following new state hooks here
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [cell, setCell] = useState('');
  const [orderSubmitted, setOrderSubmitted] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (cookiesAccepted) {
      setShowCookieConsent(false);
    }
  }, []);

  // Add the handleSubmit function here
  const handleSubmit = (e) => {
    e.preventDefault();

    const orderDetails = {
      painting: selectedPainting.title,
      name,
      email,
      cell,
    };

    console.log('Order Submitted:', orderDetails);
    alert('Order details submitted! Now you can proceed with the purchase.');

    setOrderSubmitted(true);
  };

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (cookiesAccepted) {
      setShowCookieConsent(false);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowCookieConsent(false);
  };

  const openModal = (painting) => {
    setSelectedPainting(painting);
    setSelectedVersion(0);
  };

  const closeModal = () => {
    setSelectedPainting(null);
    setSelectedVersion(0);
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <Navigation />

      <div className="container mx-auto p-8">
        <h1 className="text-4xl font-bold text-center mb-12 text-gray-800">
          Watercolor Collection
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {paintings.map((painting) => (
            <div 
              key={painting.id} 
              className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-300 hover:scale-105"
            >
              <img 
                src={painting.versions[0]} 
                alt={painting.title} 
                className="w-full h-64 object-cover cursor-pointer"
                onClick={() => openModal(painting)}
              />
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-2">{painting.title}</h2>
                <p className="text-gray-600 mb-4 text-sm">{painting.artist}</p>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-gray-900">
                    ${painting.price.toFixed(2)}
                  </span>
                  <button 
                    className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded transition duration-300"
                    onClick={() => openModal(painting)}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Footer />
        {selectedPainting && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-white rounded-lg max-w-4xl w-full mx-auto flex flex-col lg:flex-row relative m-4">
            <button 
              onClick={closeModal} 
              className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 z-60"
            >
              <X size={24} />
            </button>
            <div className="w-full lg:w-3/5 p-4">
              <img 
                src={selectedPainting.versions[selectedVersion]} 
                alt={selectedPainting.title} 
                className="w-full h-auto max-h-[70vh] object-contain rounded-lg"
              />
              <div className="flex justify-center mt-4 space-x-2 overflow-x-auto">
                {selectedPainting.versions.map((version, index) => (
                  <img 
                    key={index}
                    src={version} 
                    alt={`Version ${index + 1}`}
                    className={`w-16 h-16 flex-shrink-0 object-cover cursor-pointer rounded ${
                      selectedVersion === index ? 'border-4 border-blue-500' : 'opacity-60'
                    }`}
                    onClick={() => setSelectedVersion(index)}
                  />
                ))}
              </div>
            </div>
            <div className="w-full lg:w-2/5 p-6 flex flex-col">
              <div className="flex-grow">
                <h2 className="text-2xl font-bold mb-2">{selectedPainting.title}</h2>
                <p className="text-gray-600 mb-4">{selectedPainting.artist}</p>
                <p className="text-gray-700 mb-6">
                  {selectedPainting.description}
                </p>
              </div>
              <div className="mt-4">
                <div className="flex justify-between items-center mb-4">
                  <span className="text-3xl font-bold text-gray-900">
                    ${selectedPainting.price.toFixed(2)}
                  </span>
                  <span className="text-3xl font-bold text-gray-900">
                    R{(selectedPainting.price * 18).toFixed(2)}
                  </span>
                </div>
                <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                  <a 
                    href="https://www.paypal.com/paypalme/starklingart" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg transition duration-300 text-center flex-1"
                  >
                    Buy in $
                  </a>
                  <a 
                    href="https://pay.yoco.com/real-hey-i" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-lg transition duration-300 text-center flex-1"
                  >
                    Buy in ZAR
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

        {showCookieConsent && (
          <CookieConsent onAccept={handleAcceptCookies} />
        )}
      </div>
    </div>
  );
};

export default ArtGallery2;